module.exports = __webpack_public_path__ + "img/xls.01d3ecf9.svg";